<ng-template #content let-modal>
    <div class="modal-header">
      <h4 class="modal-title" > الملفات</h4>
      <button type="button" class="close"  (click)="modalclose()"  data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
        <div class="row">
          <div class="col-sm-12">
            <div class="card">
               <div class="row"  style=" padding: 30px;">
                 <div   style="width: 2%;" class="col-4">
                  <div class="image-area text-center bg-white" style="margin: 8px;"  >
                    <img     [src]="commercialRegisteration"  height="200" width="200"  (click)="OpenImage(commercialRegisteration)">
                    <br>
                    <!-- <p style="font-size: medium;">
                      {{item.title}}</p> -->

                  </div>
                 </div>

                 <div   style="width: 2%;" class="col-4">
                    <div class="image-area text-center bg-white" style="margin: 8px;"  >
                      <img     [src]="electronicCard"  height="200" width="200"  (click)="OpenImage(electronicCard)">
                      <br>
                      <!-- <p style="font-size: medium;">
                        {{item.title}}</p> -->
  
                    </div>
                   </div>

                   <div   style="width: 2%;" class="col-4">
                    <div class="image-area text-center bg-white" style="margin: 8px;"  >
                      <img     [src]="taxCard"  height="200" width="200"  (click)="OpenImage(taxCard)">
                      <br>
                      <!-- <p style="font-size: medium;">
                        {{item.title}}</p>
   -->
                    </div>
                   </div>

                   <div   style="width: 2%;" class="col-4">
                    <div class="image-area text-center bg-white" style="margin: 8px;"  >
                      <img     [src]="vatRegisterationCertificate"  height="200" width="200"  (click)="OpenImage(vatRegisterationCertificate)">
                      <br>
                      <!-- <p style="font-size: medium;">
                        {{item.title}}</p> -->
  
                    </div>
                   </div>
               </div>
  
</div>
        </div>
        </div>
     
    </div>
 
  </ng-template>

<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-header" style="padding-bottom: 5px !important">
                    <div class="row">
                        <div class="col-6">
                            <h5 class="pb-2">الموردين</h5>
                    
                        </div>

                        <div class="col-6 header-titles">
                            <!-- <a routerLink="/content/admin/insert-partner" class="d-block">
                                <button class="btn pull-right" type="button">
                                    <span class="m-2">إدخال شريك</span>
                                    <i class="fa fa-plus"></i>
                                </button>
                            </a> -->
                        </div>
                    </div>
                </div>
                <div class="card-block row">
                    <div class="col-sm-12 col-lg-12 col-xl-12">
                        <div class="table-responsive">
                            <table class="table table-responsive-sm">
                                <thead>
                                    <tr >
                                        <th scope="col"></th>
                                        <th scope="col">اسم الشركة</th>
                                        <!-- <th scope="col">نوع التسجيل</th>
                                        <th scope="col">نوع تسجيل اخر</th>
                                        <th scope="col">تصنيف الاعمال</th> -->
                                        <th scope="col">اسم مسؤول التواصل</th>
                                        <th scope="col">الموبايل</th>
                                        <th scope="col">رقم التسجيل الضريبي</th>
                                        <th scope="col">رقم السجل التجاري</th>
                                        <th scope="col">العنوان الرئيسي</th>
                                        <th scope="col">المحافظة</th>
                                        <th scope="col">المدينة</th>
                                        <th scope="col">الملفات</th>
                                        <!-- <th scope="col"></th> -->
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let view of suppliers;let x = index" class=" ">
                                        <td scope="row" class="p-2">{{x+1}}</td>
                                        <td class="p-2">{{view.name}}</td>
                                        <!-- <td class="p-2">{{view.supplierRegisterationTypeTitle}}</td>
                                        <td class="p-2">{{view.supplierTypeTitle}}</td>
                                        <td class="p-2">{{view.businessType}}</td> -->
                                        <td class="p-2">{{view.contactPersonName}}</td>
                                        <td class="p-2">{{view.phoneNumber}}</td>
                                        <td class="p-2">{{view.taxRegisterationNo}}</td>
                                        <td class="p-2">{{view.commercialRegisterationNo}}</td>
                                        <td class="p-2">{{view.address}}</td>
                                        <td class="p-2">{{view.governorateTitle}}</td>
                                        <td class="p-2">{{view.cityTitle}}</td>

                                        <td class="p-2">
                                            <button  style="padding: 7px; background-color: transparent;" (click)="GotoDetails(view);">
                                            <i class="fa fa-eye"></i>
                                          </button></td>
                                            <!-- <td class="font-style chose">
                                                <button class="btn pull-right"
                                                style="color: rgba(35, 118, 241, 0.667); padding: 7px"
                                                (click)="update(view.id)">
                                                <i class="fa fa-pencil"></i>
                                            </button>
                                                   <button class="btn  pull-right"  style="color: red; padding: 7px"
                                                   (click)="delete(view.id)">
                                                    <i class="fa fa-trash"></i>
                                                       </button>
                                               
                                            
                                            </td> -->
                                        </tr>
                                </tbody>
                            </table>
                            <div class="d-flex justify-content-center">
                                <pagination [boundaryLinks]="true" [maxSize]="5" [totalItems]="totalCount" previousText="&lsaquo;" nextText="&rsaquo;"
                                  firstText="&laquo;" lastText="&raquo;" [itemsPerPage]="pager.maxResultCount" [(ngModel)]="pageNumber"
                                  (pageChanged)="pageChanged($event)">
                                </pagination>
                              </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>




